import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import theme from "../../../../assests/theme";
import * as systemConfig from '../../../../../src/systemConfig.json';
import {
  MuiButton,
  MuiTextField,
  MuiEmailIcon,
  MuiPhoneIcon,
  MuiInputAdornment,
  MuiPersonIcon,
  MuiTypography,
  muiWithStyles,
  MuiGrid,
  MuiReportProblemIcon,
  MuiCheckbox
} from "../../../ui/MaterialUIComponents";
import routes from "../../../navigation/Routes";
import PageContainer from "../../../ui/PageContainer";
import MaterialUIForm from "material-ui-form";
import { withRouter } from "react-router";
import '../../../ui/scrollbarForLog.css'
import spinner from "../../../ui/icons/spinner.gif";
import { createHashHistory } from "history";
import { toast } from 'react-toastify';
import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/plain.css';
import startsWith from 'lodash.startswith';
import * as Constants from '../../../../constants';
const history = createHashHistory();
const styles = theme => ({
  number: {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    }
  }
});

export const Username_Exists_Exception = "UsernameExistsException"
class SignUpForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: "",
      username: "",
      password: "",
      email: "",
      phoneNumber: "",
      firstName: "",
      lastName: "",
      confirmPassword: "",
      spinnerFlag: false,
      isTcAccepted:false
    };
    this.handleOnChange = this.handleOnChange.bind(this)
  }

  handleOnChange(value, data, event) {
    this.setState({ "phoneNumberVal": value.replace(/[^0-9]+/g, '').slice(data.dialCode.length) })
    this.setState({ "phoneNumber": value.replace(/[- ()]/g, '') })
  }
  handleChangeForPhoneNumber = (event, name) => {


    this.setState({
      [name]: event,
      error: ""
    })
  }
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      error: ""
    });
  };

  validate = () => {
    const i18n = this.props.i18n
    var password = this.state.password;

    if (!(this.state.firstName).match(/^[A-Za-z ]+$/)) {
      this.setState({ error: i18n.signup.firstNameValidation })
      return false;
    }
    if (!(this.state.lastName).match(/^[A-Za-z ]+$/)) {
      this.setState({ error: i18n.signup.lastNameValidation })
      return false;
    }

    if (this.state.phoneNumberVal !== "" && this.state.phoneNumberVal !== undefined) {
      if (this.state.phoneNumberVal.length != 10) {
        this.setState({ error: i18n.signup.phoneNumberValidation });
        return false;
      }
    } else if (this.state.phoneNumberVal === undefined) {
      this.setState({ error: i18n.signup.phoneNumberIsRequired });
      return false;
    }
    if(this.state.isTcAccepted === false){
      this.setState({ error: i18n.signup.acceptTermsAndConditions});
      return false;
    }

    return true;

  };

  onSubmit = () => {
    let formValid = this.validate();
    if (formValid == true) {
      this.registerUser();
      this.setState({ spinnerFlag: true });
    }
  }


  registerUser = async () => {
    try {
      var tempData = this.state;
      const i18n = this.props.i18n

      /* if (tempData.phoneNumber.trim() !== "") {
        tempData.phoneNumber = "+91" + tempData.phoneNumber;
      } */
      if (!startsWith(tempData.phoneNumber, '+')) {
        tempData.phoneNumber = "+" + tempData.phoneNumber
      }
      tempData.email = tempData.email.toLowerCase()
      var userData = JSON.stringify(tempData);
      var result = null;
      result = await this.props.signUp(userData);

      if (result._id != undefined) {
        history.push('/')
        toast(i18n.signup.successMessage,
          {
            autoClose: 4000,
            onClose: (function () {

              window.location.href = '/'
            })
          }

        )

      }
    } catch (error) {
      this.setState({ error: error, spinnerFlag: false });
    }
  };

  manageErrorsFromCognitoForSignUp = (errorCode, errorMessage) => {
    const i18n = this.props.i18n
    switch (errorCode) {
      case Username_Exists_Exception:
        return i18n.cognitoErrorMessages.UsernameExistsException_SignUp;
      default:
        return errorMessage;
        break;
    }
  }
  handleCheck = (event) => {
    this.setState({isTcAccepted:event.target.checked})
  }
  render() {
    const { i18n } = this.props
    return (
      <div className="App" style={{paddingTop:"64px"}}>
          <div><MuiTypography variant={theme.typographyStyles.H4} color="primary">
            {i18n.signup.signUpPageTitle}
          </MuiTypography>

            <MaterialUIForm onSubmit={this.onSubmit}>
              <MuiTextField
                id="firstName"
                label="First Name"
                onChange={this.handleChange("firstName")}
                margin="normal"
                data-validators="isRequired,isAlpha"
                placeholder={i18n.signup.firstNamePlaceHolder}
                type="text"
                required
                style={theme.muiTextFieldStyleForMainScreen}
                InputProps={{
                  startAdornment: (
                    <MuiInputAdornment position="start">
                      <MuiPersonIcon color="primary" />
                    </MuiInputAdornment>
                  )
                }}
              />
              <br />
              <MuiTextField
                id="lastName"
                label="Last Name"
                onChange={this.handleChange("lastName")}
                margin="normal"
                data-validators="isRequired,isAlpha"
                placeholder={i18n.signup.lastNamePlaceHolder}
                type="text"
                required
                style={theme.muiTextFieldStyleForMainScreen}
                InputProps={{
                  startAdornment: (
                    <MuiInputAdornment position="start">
                      <MuiPersonIcon color="primary" />
                    </MuiInputAdornment>
                  )
                }}
              />
              <br />
              {/* <MuiTextField
            id="phoneNumber"
            label="Phone Number"
            onChange={this.handleChange("phoneNumber")}
            margin="normal"
            className={this.props.classes.number}
            placeholder="Enter 10 digit mobile Number"
            type="number"
            style={theme.muiTextFieldStyleForMainScreen}
            InputProps={{
              startAdornment: (
                <MuiInputAdornment position="start">
                  <MuiPhoneIcon color="primary" />
                </MuiInputAdornment>
              )
            }}
          /> */}
              <PhoneInput
                id="phoneNumber"
                isValid={(inputNumber, undefined, onlyCountries) => {
                  return onlyCountries.some((countryObj) => {
                    return startsWith(inputNumber, countryObj.dialCode) || startsWith(countryObj.dialCode, inputNumber);
                  });
                }}
                onChange={this.handleOnChange}
                inputClass='phone-input-signup'
                // style={theme.muiTextFieldStyleForMainScreen}
                placeholder={i18n.signup.phoneNumberPlaceHolder}
                containerClass="phone-input-signup-container react-tel-input"
                // disabled={this.props.isEditNotAllowed}
                // disableDropdown={this.props.isEditNotAllowed}
                label="Phone Number"
                value={this.state.phoneNumber}
                country={Constants.PHONE_DEFAULT_COUNTRY_CODE}
                inputProps={{
                  name: 'phoneNumber',
                  required: true
                }}
              />
              <br />
              <MuiTextField
                id="username"
                label="Email"
                onChange={this.handleChange("email")}
                data-validators="isRequired,isEmail"
                margin="normal"
                placeholder={i18n.signup.exampleEmailPlacehoder}
                type="email"
                required
                style={theme.muiTextFieldStyleForMainScreen}
                InputProps={{
                  startAdornment: (
                    <MuiInputAdornment position="start">
                      <MuiEmailIcon color="primary" />
                    </MuiInputAdornment>
                  )
                }}
              />
              <br />
              <MuiGrid container>
                <MuiCheckbox color="primary" alignItems="flex-start"  onChange={(event) => this.handleCheck(event)} checked={this.state.isTcAccepted}/> 
                <MuiGrid item container direction="column" justify="center" xs alignItems="flex-start">
                  <MuiGrid><MuiTypography variant={theme.typographyStyles.body2} color='primary'>I have read the <a href={systemConfig.privacyPolicyURL} target="_blank">
              
                Privacy Policy
      
            </a></MuiTypography></MuiGrid>
                  <MuiGrid><MuiTypography variant={theme.typographyStyles.body2} color='primary'>I agree to the <a href={systemConfig.termsAndConditionsURL} target="_blank">Terms and Conditions</a></MuiTypography></MuiGrid>
                </MuiGrid>
              </MuiGrid>
              <MuiTypography
                variant={theme.typographyStyles.CAPTION}
                color="error"
              >
                {this.state.error}
              </MuiTypography>

              <br />
              <MuiGrid container justify="space-between">
                <MuiButton
                  id="reset"
                  style={theme.secondaryButtonStyle}
                  type="reset"
                >
                  {i18n.signup.resetButton}
                </MuiButton>

                {this.state.spinnerFlag ?
                  <img src={spinner} alt="none" style={theme.spinnerImgStyle} />
                  :
                  <MuiButton
                    id="signUpBtn"
                    style={theme.primaryButtonStyle}
                    type="submit"
                  >
                    {i18n.signup.signUpButton}
                  </MuiButton>
                }
              </MuiGrid>
              <br />

              <Link to={routes.main} style={theme.linkStyle}>
                <MuiTypography
                  id="signIn"
                  variant={theme.typographyStyles.CAPTION}
                  color="primary"
                >
                  {i18n.signup.allreadyRegistered}
                </MuiTypography>
              </Link>
            </MaterialUIForm></div>
      </div>

    );
  }
}
SignUpForm.contextTypes = {
  store: PropTypes.object,
  state: PropTypes.string
};
SignUpForm.propTypes = {
  history: PropTypes.object,
  state: PropTypes.string
};

const SignUp = props => (
 <PageContainer cardHeight="500">
    <SignUpForm {...props} />
    </PageContainer>
);
const componentStyle = theme => ({
  input: {
    display: "none"
  },
  textField: {  
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200
  }
});
export default muiWithStyles(styles)(withRouter(SignUp));
//aric.erwin@andyes.net